// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.zero[data-v-3a78a7f2]{\n    display: inline-block;width: 100px;\n}\n.searchBox[data-v-3a78a7f2]{\n    align-items: center;\n}\n.createNewCourseBox .createNewCourse[data-v-3a78a7f2]{\n    margin-right: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
